import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuidaCompleta from "../pages/articoli/guida-completa-itaobuy-spreadsheet/page";
import TemplatePage from "../pages/articoli/template-itaobuy-spreadsheet/page";
import PrezziPage from "../pages/articoli/tracciamento-prezzi-itaobuy/page";
import OrdiniPage from "../pages/articoli/gestione-ordini-itaobuy/page";
import ConfrontoPage from "../pages/articoli/confronto-strumenti-itaobuy/page";
import AcquistiPage from "../pages/articoli/guida-acquisti-itaobuy/page";
import DatabasePage from "../pages/articoli/database-prodotti-itaobuy/page";
import PrincipiantiPage from "../pages/articoli/principianti-itaobuy-spreadsheet/page";
import AutomazionePage from "../pages/articoli/automazione-itaobuy-spreadsheet/page";
import SicurezzaPage from "../pages/articoli/sicurezza-itaobuy-spreadsheet/page";
import CollaborazionePage from "../pages/articoli/collaborazione-itaobuy/page";
import OttimizzazionePage from "../pages/articoli/ottimizzazione-itaobuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articoli/guida-completa-itaobuy-spreadsheet",
    element: <GuidaCompleta />,
  },
  {
    path: "/articoli/template-itaobuy-spreadsheet",
    element: <TemplatePage />,
  },
  {
    path: "/articoli/tracciamento-prezzi-itaobuy",
    element: <PrezziPage />,
  },
  {
    path: "/articoli/gestione-ordini-itaobuy",
    element: <OrdiniPage />,
  },
  {
    path: "/articoli/confronto-strumenti-itaobuy",
    element: <ConfrontoPage />,
  },
  {
    path: "/articoli/guida-acquisti-itaobuy",
    element: <AcquistiPage />,
  },
  {
    path: "/articoli/database-prodotti-itaobuy",
    element: <DatabasePage />,
  },
  {
    path: "/articoli/principianti-itaobuy-spreadsheet",
    element: <PrincipiantiPage />,
  },
  {
    path: "/articoli/automazione-itaobuy-spreadsheet",
    element: <AutomazionePage />,
  },
  {
    path: "/articoli/sicurezza-itaobuy-spreadsheet",
    element: <SicurezzaPage />,
  },
  {
    path: "/articoli/collaborazione-itaobuy",
    element: <CollaborazionePage />,
  },
  {
    path: "/articoli/ottimizzazione-itaobuy",
    element: <OttimizzazionePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;